import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram } from 'lucide-react';

const Footer: React.FC = () => {
  const scrollTop = (e: React.MouseEvent) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-primary-dark text-gray-300">
      {/* Sección superior - más compacta en móvil */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 md:py-12">
        {/* En móvil: layout compacto centrado */}
        <div className="md:hidden space-y-6">
          {/* Logo y slogan centrados */}
          <div className="text-center">
            <div className="text-xl font-serif font-bold text-white">Frahda Studio</div>
            <p className="mt-1 text-xs text-gray-400">Belleza con propósito.</p>
          </div>

          {/* Links principales en 2 columnas balanceadas */}
          <div className="grid grid-cols-2 gap-x-8 gap-y-3 text-sm max-w-md mx-auto">
            <Link to="/products" className="hover:text-primary-accent transition-colors text-center">Tienda</Link>
            <a href="/#servicios" className="hover:text-primary-accent transition-colors text-center">Servicios</a>
            <Link to="/cursos" className="hover:text-primary-accent transition-colors text-center">Cursos</Link>
            <Link to="/eventos" className="hover:text-primary-accent transition-colors text-center">Eventos</Link>
            <Link to="/terms" className="hover:text-primary-accent transition-colors text-center">Términos</Link>
            <Link to="/privacy" className="hover:text-primary-accent transition-colors text-center">Privacidad</Link>
          </div>

          {/* Contacto compacto */}
          <div className="text-center text-xs space-y-1">
            <p>Matías Rojas 1541, Antofagasta</p>
            <p>+56 9 6543 7000</p>
            <p className="text-primary-accent">frada.studio.afta@gmail.com</p>
          </div>
        </div>

        {/* En tablet/desktop: layout original en grid */}
        <div className="hidden md:grid grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Col 1: Logo y slogan */}
          <div>
            <div className="text-2xl font-serif font-bold text-white">Frahda Studio</div>
            <p className="mt-3 text-sm">Belleza con propósito.</p>
          </div>

          {/* Col 2: Navegación */}
          <div>
            <h4 className="font-serif font-bold text-white mb-4">Navegación</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/products" className="hover:text-primary-accent transition-colors">Tienda</Link></li>
              <li><a href="/#servicios" className="hover:text-primary-accent transition-colors">Servicios</a></li>
              <li><Link to="/cursos" className="hover:text-primary-accent transition-colors">Cursos</Link></li>
              <li><Link to="/eventos" className="hover:text-primary-accent transition-colors">Eventos</Link></li>
            </ul>
          </div>

          {/* Col 3: Políticas */}
          <div>
            <h4 className="font-serif font-bold text-white mb-4">Políticas</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/terms" className="hover:text-primary-accent transition-colors">Términos y condiciones</Link></li>
              <li><Link to="/privacy" className="hover:text-primary-accent transition-colors">Política de privacidad</Link></li>
              <li><a href="/#faq" className="hover:text-primary-accent transition-colors">Preguntas frecuentes</a></li>
            </ul>
          </div>

          {/* Col 4: Contacto */}
          <div>
            <h4 className="font-serif font-bold text-white mb-4">Contacto</h4>
            <ul className="space-y-2 text-sm">
              <li>Matías Rojas 1541, Antofagasta, Chile</li>
              <li>+56 9 6543 7000</li>
              <li>frada.studio.afta@gmail.com</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Sección inferior - más compacta */}
      <div className="border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 md:py-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-3 md:gap-4">
            {/* Redes sociales */}
            <div className="flex items-center gap-4">
              <a href="https://www.instagram.com/frada_studio" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-gray-300 hover:text-primary-accent transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-gray-300 hover:text-primary-accent transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
            </div>

            {/* Copyright */}
            <div className="text-center text-xs text-gray-400 order-last md:order-none">
              © 2025 Frahda Studio
            </div>

            {/* Volver Arriba */}
            <a href="#" onClick={scrollTop} className="text-gray-300 hover:text-primary-accent transition-colors text-xs md:text-sm flex items-center gap-1">
              <span>Volver Arriba</span>
              <span>↑</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;